// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"BRwQN","Checkbox__Input":"uXEXe","Checkbox__Label":"TWbGW","Checkbox__Figure":"WqQ0P","Checkbox__Icon":"mVv6j","Checkbox__Text":"Vi13a"};